/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Button, Segment, TextArea, Dimmer, Loader } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { changeBrowserTabTitle } from '../slices/browserTabTitle/browserTabTitleSlice';
import { useNavigate } from 'react-router-dom';
import { selectCurrentUserAdmin, selectCurrentUserApiToken } from '../slices/currentUser/currentUserSlice';
import GenericToggleButtons from './GenericToggleButtons';
import submitBulkResources from '../functions/submitBulkResources';

// eslint-disable-next-line no-empty-pattern
const JsonBulkEntryPage = ({ }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const isAdmin = useSelector(selectCurrentUserAdmin);

    const [fhirEntryState, setFhirEntryState] = useState({
        "fhirBulkEntry": "",
        "status": "active"
    });

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Resource JSON Bulk Entry"));
    }, []);

    return <div>
        {fhirEntryState.bulkSubmitting &&
            <Dimmer className={"loadingDimmer"} active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>
        }
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            <h3 style={{
                textAlign: "center", color: "#AC3B61",
                marginTop: "2px", marginBottom: "0px"
            }}>
                Resource JSON Bulk Entry (Limit of 1,000 resources at a time)</h3>
            <br />
            {apiToken ?
                <>
                    <TextArea placeholder='Paste your array of JSON resources here'
                        style={{ minHeight: 300, width: "60%" }}
                        value={fhirEntryState.fhirBulkEntry}
                        onChange={(e) => {
                            setFhirEntryState(prevState => {
                                return {
                                    ...prevState,
                                    "fhirBulkEntry": e.target.value
                                };
                            });
                        }} />
                    <br /><br />
                    <GenericToggleButtons thin={true} boxes={true} togglable={false}
                        values={["active", "draft"]}
                        labels={["Publish (anyone can view)", "Draft (only editors can view)"]}
                        fieldLabel={"status"} elementName={"status"}
                        startingValue={fhirEntryState.status} setter={setFhirEntryState}
                    />
                    <br />
                    <br />
                    <Button className="formButton positive" content="Submit" compact
                        onClick={async () => {
                            setFhirEntryState(prevState => {
                                return {
                                    ...prevState,
                                    "bulkSubmitting": true
                                };
                            });
                            let fois = await submitBulkResources(apiToken, fhirEntryState, false, isAdmin);
                            if (fois) {
                                navigate("/");
                            } else {
                                alert("Something went wrong.");
                            }
                            setFhirEntryState(prevState => {
                                return {
                                    ...prevState,
                                    "bulkSubmitting": false
                                };
                            });
                        }}
                    />
                </>
                :
                <p>Please login. (If you do not have an account click Sign In and log in with your Google Account.)</p>
            }
        </Segment>
    </div>;
};

export default JsonBulkEntryPage;